"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchUploadPublisher = void 0;
var R = __importStar(require("ramda"));
var rxjs_1 = require("rxjs");
var fetchUploadPublisher = function (byteCount, url, logger) {
    var bufferSize = 1e6;
    var buffer = new Uint8Array(R.repeat(Number('0'), bufferSize < byteCount ? byteCount : byteCount));
    var abortController = new AbortController();
    var signal = abortController.signal;
    function wait(milliseconds) {
        return new Promise(function (resolve) { return setTimeout(resolve, milliseconds); });
    }
    var stream = new ReadableStream({
        start: function (controller) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, wait(1000)];
                        case 1:
                            _a.sent();
                            controller.enqueue('00000');
                            return [4 /*yield*/, wait(1000)];
                        case 2:
                            _a.sent();
                            controller.enqueue('0000000000');
                            return [4 /*yield*/, wait(1000)];
                        case 3:
                            _a.sent();
                            controller.enqueue('000000000000000000');
                            return [4 /*yield*/, wait(1000)];
                        case 4:
                            _a.sent();
                            controller.enqueue('0000000');
                            return [4 /*yield*/, wait(1000)];
                        case 5:
                            _a.sent();
                            controller.enqueue('00000000');
                            controller.close();
                            return [2 /*return*/];
                    }
                });
            });
        },
    }).pipeThrough(new TextEncoderStream());
    return new rxjs_1.Observable(function (subscriber) {
        try {
            var formData = new FormData();
            formData.set("file-upload", new Blob([buffer]));
            var updateProgress_1 = function (len) {
                logger.info("uploadPublisher - updateProgress, len = ".concat(len));
                subscriber.next(len);
            };
            var responsePromise = fetch(url, {
                method: "POST",
                // body: formData,
                body: stream,
                headers: {
                    'Content-Type': 'text/plain',
                },
                /*
                body: new ReadableStream<Uint8Array>({
                    start: (c) => {
                        console.log(`uploadPublisher - start, buffer.length = ${buffer.length}`);
                        c.enqueue(buffer);
                    },
                    pull: (c) => {
                        console.log(`uploadPublisher - pull, c.desiredSize = ${c.desiredSize}`);
                        updateProgress(c.desiredSize!);
                    },
                }),
                */
                signal: signal,
            });
            responsePromise.then(function (response) {
                logger.info("uploadPublisher responsePromise, response = ".concat(response));
                if (!response.ok) {
                    logger.info("uploadPublisher responsePromise, response not ok");
                    subscriber.error(response);
                    return;
                }
                updateProgress_1(0);
            }).catch(function (err) {
                logger.error(err, "uploadPublisher - error 1");
                subscriber.error(err);
            });
        }
        catch (err) {
            logger.error(err, "uploadPublisher - error 2");
            subscriber.error(err);
        }
    });
};
exports.fetchUploadPublisher = fetchUploadPublisher;
//# sourceMappingURL=fetchUploadPublisher.js.map